import banner from './banner.png'
import icon00 from './00.png'
import icon01 from './01.png'
import icon10 from './10.png'
import icon11 from './11.png'
import icon20 from './20.png'
import icon21 from './21.png'
let iconList = [
    {
        nomal: icon00,
        selected: icon01
    },
    {
        nomal: icon10,
        selected: icon11
    },
    {
        nomal: icon20,
        selected: icon21
    }
]
export {
    banner as banner,
    iconList as iconList
}